import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import clients from "../icons/clientsBlack.svg";
import dash from "../icons/dashboardBlack.svg";
import home from "../icons/homeBlack.svg";
import importacao from "../icons/importacaoBlack.svg";
import orderIcon from "../icons/orderIconBlack.svg";
import products from "../icons/productsBlack.svg";
import config from "../icons/settingsBlack.svg";
import { generateFileUrl } from "../requestMethods";
import { useCompany } from "./context/CompanyContext";
import { useSidebar } from "./context/SidebarContext";
import AccountMenu from "./menu/AccountMenu";
import "./topbar.css";
import Toolbar from "@mui/material/Toolbar";
import { styled, createTheme, ThemeProvider } from "@mui/material/styles";
import MuiAppBar from "@mui/material/AppBar";

const COLLAPSED_WIDTH = 60;
const EXPANDED_WIDTH = 200;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "sidebarwidth",
})(({ theme, sidebarwidth }) => ({
  backgroundColor: "white",
  marginLeft: sidebarwidth,
  width: `calc(100% - ${sidebarwidth}px)`,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
}));

export default function Topbar(props) {
  const { imgLogo } = useCompany();
  const { collapsed } = useSidebar();
  const [label, setLabel] = useState();
  const [logo, setLogo] = useState();
  const currentTitle = useSelector((state) => state.titleRef.currentTitle);

  const sidebarwidth = collapsed ? COLLAPSED_WIDTH : EXPANDED_WIDTH;
  // const handleClick = () => {
  //   logOut(dispatch);
  //   nav(`login`);
  // };
  useEffect(() => {
    let url = window.location.pathname;
    let parts = url.split("/");
    let lastPart = parts.pop() || parts.pop();

    // eslint-disable-next-line default-case
    switch (lastPart) {
      case "home":
        setLabel("Home");
        setLogo(home);
        break;
      case "customers":
        setLabel("Clientes");
        setLogo(clients);
        break;
      case "orders":
        setLabel("Pedidos");
        setLogo(orderIcon);
        break;
      case "products":
        setLabel("Produtos");
        setLogo(products);
        break;
      case "tabdashboard":
        setLabel("Dashboard");
        setLogo(dash);
        break;
      case "tabconfigs":
        setLabel("Configurações");
        setLogo(config);
        break;
      case "tabimports":
        setLabel("Importações");
        setLogo(importacao);
        break;
    }
  }, [window.location.pathname]);

  return (
    <>
      <AppBar sidebarwidth={sidebarwidth}>
        <Toolbar
          sx={{
            pr: "24px", // keep right padding when drawer closed
          }}
        >
          <table width="100%" className="tableBorder">
            <tbody>
              <tr>
                <td width="20%" className="center">
                  <div className="divtitle">
                    <img src={logo} />
                    <span className="title">
                      {currentTitle && currentTitle.title}
                    </span>
                  </div>
                </td>
                <td width="60%" className="center">
                  <img className="logoimg" src={generateFileUrl(imgLogo)} />
                </td>
                <td width="20%" className="right">
                  <AccountMenu />
                </td>
              </tr>
            </tbody>
          </table>
        </Toolbar>
      </AppBar>
    </>
  );
}
